import MasterModal from 'components/organisms/masterModal';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import BaseForm from 'components/atoms/base-form';
import { NoReadingsForm } from 'components/organisms/device-troubleshoot-templates/templates/deviceTroubleshootForm';
import FormItemWrapper from 'components/molecules/rpm-alert-assessment/formItemWrapper';

import s from '../../styles.module.scss';
import { useNoReadings } from '../../hooks/use-no-readings-modal';
import { useStoreModalValue } from '../../hooks/use-store-modal-value';
import { noReadingsValidationSchema } from '../../validation-schema';

import type { INoReadingsModalProps } from '../../types';
import type { FC } from 'react';

const NoReadingsModal: FC<INoReadingsModalProps> = ({
  isOpen,
  handleSubmit,
  closeModal,
  whichPerson,
  patientGuid,
  otherPerson,
}) => {
  const { t } = useTranslation();
  const { initialValues, onSaveForm } = useNoReadings({
    closeModal,
    handleSubmit,
    whichPerson,
    otherPerson,
  });

  const type = 'min';

  type TInitialValues = typeof initialValues;
  const { parsedData, setModalValuesToStorage } =
    useStoreModalValue<TInitialValues>({
      modalName: `noReadings_${patientGuid}`,
    });

  const formik = useFormik({
    initialValues: parsedData ?? initialValues,
    onSubmit: (data) => {
      setModalValuesToStorage(data);
      onSaveForm(data);
    },
    validateOnChange: false,
    validationSchema: noReadingsValidationSchema(),
  });

  const onSave = () => {
    formik.submitForm();
  };

  const expandableExtraFields = ['realTimeReading'];

  return (
    <>
      <MasterModal
        isOpen={isOpen}
        toggle={closeModal}
        title={t('labels.RPMSpecialistTemplate')}
        onSave={onSave}
        size="medium"
        dataCy="RPMSpecialistTemplate"
      >
        <BaseForm formik={formik}>
          <div className={s.wrapper}>
            {NoReadingsForm.map((formItem, index) => {
              const isShowExtraFields = expandableExtraFields.includes(
                formItem.name,
              )
                ? formik.getFieldMeta(formItem.name)?.value === 'yes'
                : undefined;
              return (
                <FormItemWrapper
                  formik={formik}
                  index={index}
                  formItem={formItem}
                  type={type}
                  requiredSymptomFields={[]}
                  isShowExtraFields={isShowExtraFields}
                />
              );
            })}
          </div>
        </BaseForm>
      </MasterModal>
    </>
  );
};

export default NoReadingsModal;
